/**
 * Gercek yuklenen fotograf varsa onu gosterir, yoksa bas harf dairesine duser.
 *
 * Header'daki profil menusu (`ChatScreen.tsx`) VE sohbetteki kullanici
 * mesaji satiri (`HistoryMessage.tsx`) ayni bilesini paylasiyor - ikisi de
 * "fotograf mi, bas harf mi" karari icin AYNI mantigi tekrarlamamali.
 */
export function ProfileAvatar({
  avatarId,
  initial,
  className,
}: {
  avatarId?: string | null
  initial: string
  className: string
}) {
  if (avatarId) {
    return <img className={className} src={`/api/attachments/${avatarId}`} alt="" />
  }
  return (
    <span className={className} aria-hidden="true">
      {initial}
    </span>
  )
}
